<template>
  <v-app-bar id="top-app-bar" color="white">
    <v-btn icon small class="ml-3">
      <v-icon id="menu-trigger-icon" class="material-icons-outlined" @click="$emit('mini-pressed')">
        sort
      </v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <div>
      <top-bar-notification-center id="app-bar-notifs" class="mr-6" />
      <v-menu bottom center offset-y content-class="theme-menu">
        <template v-slot:activator="{ on, attrs }">
          <div id="app-bar-user-menu">
            <span
              id="app-bar-user-name"
              class="text weight-500 color-black-alt-lighten-1"
              >{{ getUserData.firstname }} {{ getUserData.lastname }}</span
            >
            <v-btn icon v-bind="attrs" v-on="on" small>
              <v-icon>expand_more</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon class="material-icons-outlined"
                >power_settings_new</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title @click="logout">Déconnexion</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script type="text/javascript">
import topBarNotificationCenter from "./top-bar-notification-center";

export default {
  name: "top-app-bar",
  components: {
    topBarNotificationCenter,
  },
  data() {
    return {};
  },
  computed: {
    getUserData() {
      return this.$store.state.auth.users.data;
    },
  },
  created() {},
  methods: {
    logout() {
      this.$store.commit("auth/logoutUser");
    },
  },
};
</script>

<style lang="scss">
#top-app-bar {
  box-shadow: $shadow-light-02;

  #menu-trigger-icon {
    color: $color-secondary;
  }

  #app-bar-notifs {
    display: inline-block;
  }

  #app-bar-user-menu {
    display: inline-block;
    #app-bar-user-name {
      font-family: $font-alt;
    }
  }
}
</style>
